import { z } from 'zod';

export type TTag = z.infer<typeof tagSchema>;

export const tagSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    color: z.string(),
  }),
});
